<template>
    <div class="index" id="index">
        <div style="position:fixed;left:0px;top:150px">reason:{{ reason }}</div>
        <div v-if="isShowImg" class="start">
            <img v-if="isSpeaking" @click="startRecorder()" src="../assets/img/end.png" alt="">
            <img v-if="!isSpeaking" @click="stopRecorder()" src="../assets/img/start.png" alt="">
        </div>
        <video id="sonVideos" style="position:absolute" v-show="isShowImg" autoplay webkit-playsinline="true" loop="true" playsinline="true" x5-video-player-type="h5" x5-video-orientation="portraint" x5-video-player-fullscreen="true">
            <source type="video/mp4">
        </video>
        <video id="playVideos" v-show="isShowImg" autoplay webkit-playsinline="true" playsinline="true" x5-video-player-type="h5" x5-video-orientation="portraint" x5-video-player-fullscreen="true" :loop='false'>
            <source type="video/mp4">
        </video>
        <img v-for="(item,index) in dataObj.imgList" :key="index" id="bgImg" class="bgImg" v-show="isShowImg" :src="require(`../assets/${urlId}/img/${item.imgUrl}`)" alt="">
        <img v-if="showLoading" style="width:180px;position:fixed;left:50%;margin-left:-90px;top:40%;z-index:10000" src="../assets/img/loading2.gif" alt="">
        <div v-if="isShowImg" class="chat-item">
            <div class="item-list">{{chatItem}} </div>
        </div>
    </div>
</template>
<script>
    import Recorder from 'js-audio-recorder'
    const recorder = new Recorder({
        sampleBits: 16,                 // 采样位数，支持 8 或 16，默认是16
        sampleRate: 16000,              // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
        numChannels: 1,                 // 声道，支持 1 或 2， 默认是1
        compiling: true,//(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
    })
    export default {
        name: 'home-1',
        data () {
            return {
                //波浪图-播放
                timer: null,
                ws: null,
                privateContent: '',
                roomId: '',
                isPhone: false,
                elevideo: null,
                videoTimeLen: '',
                isSpeaking: true,
                flag: false,
                winWidth: '',
                winHeight: '',
                isShowImg: false,
                dataObj: {"videoObj":{"width":0,"left":0,"top":0,"layer":1,"videoUrl":"","videoWidth":"","videoHeight":"","percent":"","leftAttribute":"","topAttribute":""},"imgList":[]},
                sonVideo: '',
                showLoading: false,
                chatItem: '',
                urlId: '',
                pageIndex: '',
                reason: '',
            }
        },
        created()  {
            if (navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
                this.getUserMedia({ video: true, audio: true }); // 调用用户媒体设备，访问摄像头、录音
            } else {
                console.log("你的浏览器不支持访问用户媒体设备");
            }
        },
        mounted(){
            let that = this
            this.urlId = this.$route.query.id;
            console.log(this.urlId)
            this.elevideo = document.getElementById('playVideos')
            this.sonVideo = document.getElementById('sonVideos')
            this.pageIndex = document.getElementById('index')
            this.elevideo.addEventListener('canplay', function () {
                that.dataObj.videoObj.videoWidth = this.videoWidth
                that.dataObj.videoObj.videoHeight = this.videoHeight
                that.getCriticalCoefficient()
            })
            this.elevideo.addEventListener('ended', function () {
                console.log("播放结束")
                that.flag = false
                that.initVideo()
                if(!that.isSpeaking){
                    that.startRecorder()
                }
            }); 
            this.getWidth()
            this.showConfirm()
            window.onresize = function(){
                that.getWidth()
                that.getCriticalCoefficient()
            }
        },
        methods: {
            // 开始录音
            startRecorder () {
                recorder.start().then(() => {
                    this.isSpeaking = false
                    console.log("开始绘制")
                    this.ws = new WebSocket("wss://experience.ixiaowen.net:2443/wss/realTimeSpeechRecognition")
                    this.ws.binaryType = 'arraybuffer';
                    let that = this
                    this.ws.onopen = function () {
                        that.ws.send('start')
                        that.timer = setInterval(() => {
                            let data = recorder.getNextData()
                            for(let i = 0; i < data.length; i++){
                                that.ws.send(data[i])
                            }
                        }, 500)
                    }
                    this.ws.onmessage = function (evt) {
                        var received_msg = evt.data
                        console.log(received_msg)
                        if(that.flag == false){
                            that.sendPrivate(received_msg)
                        }
                    }
                }, (error) => {
                    // 出错了
                    console.log(`${error.name} : ${error.message}`);
                });
            },
            // 结束录音
            endRecorder () {
                this.ws.send('stop')
                recorder.stop()
                clearInterval(this.timer)
            },
            stopRecorder () {
                this.ws.send('stop')
                this.isSpeaking = true
                recorder.stop()
                clearInterval(this.timer)
            },
            /*-----------------视频处理------------------->*/
            initVideo() {
                this.flag = false
                this.dataObj.videoObj.videoUrl = require(`../assets/${this.urlId}/video/default.mp4`)
                this.elevideo.src = this.dataObj.videoObj.videoUrl;
                this.elevideo.play()
                console.log("播放初始化视频")
                // this.currentState = 1
                this.elevideo.removeAttribute("loop")
                this.elevideo.setAttribute("loop", "true");
                
            },
            changeUrl(url) {
                this.flag = true
                this.dataObj.videoObj.videoUrl = require(`../assets/${this.urlId}/video/${url}`)
                this.elevideo.src = this.dataObj.videoObj.videoUrl;
                // this.currentState = 2
                this.elevideo.removeAttribute("loop")
            },
            sendPrivate(content) {
                this.chatItem = content
                this.flag = true
                this.endRecorder()
                let obj = {}
                obj.role = 'user'
                obj.content = content
                // this.axios.post('http://www.sipgo.cn/api/project/chat', {//本地用绝对路径
                this.axios.post('/api/project/chat', {//打包版本用相对路径
                    projectId: this.urlId,
                    roomId: this.roomId,
                    content: content
                })
                .then(response=> {
                    if(response.data.code == 0){
                        let that = this
                        let newObj = {}
                        newObj.role = 'robot'
                        let arr = response.data.data.responseContent
                        console.log(arr)
                        let brr = arr.split("@@")
                        let str = JSON.parse(brr[1])
                        newObj.content = brr[0]
                        setTimeout(()=>{
                            this.chatItem = brr[0]
                        },1000)
                        if(brr.length > 1){
                            this.changeUrl(str.videoObj.videoUrl)
                        }

                        this.dataObj = str
                        setTimeout(()=>{
                            let imgList = document.querySelectorAll(".bgImg")
                            for(let i = 0; i < imgList.length; i++){
                                this.dataObj.imgList[i].eleImg = imgList[i]
                                this.dataObj.imgList[i].eleImg.onload=function(){
                                    console.log(this.width)
                                    that.dataObj.imgList[i].imgWidth = this.width
                                    that.dataObj.imgList[i].imgHeight = this.height
                                };
                            }
                        })
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            randomTime() {
                let max = 3000;
                let min = 1000;
                return Math.round(Math.random()*(max-min)+min)
            },
            getRoomId() {
                // this.axios.post('http://www.sipgo.cn/api/project/chat', {//本地用绝对路径
                this.axios.post('/api/project/chat', {//打包版本用相对路径
                    projectId: this.urlId,
                    roomId: '',
                    content: ''
                })
                .then(response=> {
                    if(response.data.code == 0){
                        let that = this
                        this.roomId = response.data.data.roomId
                        this.chatItem = response.data.data.responseContent.split("@@")[0]
                        if(response.data.data.responseContent.split("@@").length > 1){
                            let str = JSON.parse(response.data.data.responseContent.split("@@")[1])
                            this.changeUrl(str.videoObj.videoUrl)
                            this.dataObj = str
                            setTimeout(()=>{
                                let imgList = document.querySelectorAll(".bgImg")
                                for(let i = 0; i < imgList.length; i++){
                                    this.dataObj.imgList[i].eleImg = imgList[i]
                                    this.dataObj.imgList[i].eleImg.onload=function(){
                                        console.log(this.width)
                                        that.dataObj.imgList[i].imgWidth = this.width
                                        that.dataObj.imgList[i].imgHeight = this.height
                                    };
                                }
                                
                            })
                            setTimeout(()=>{
                                this.isShowImg = true
                                this.showLoading = false
                                this.pageIndex.style.background = '#979797';
                            },200)
                        }
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            showConfirm() {
                let that = this
                const h = this.$createElement;
                this.$info({
                    title: '开始对话',
                    content: h('div', {}, [
                        h('p', '即将与数字人对话，请确保设备麦克风耳机正常，系统需要打开您的麦克风权限，请在弹窗后点击允许'),
                    ]),
                    onOk() {
                        that.initVideo()
                        that.getRoomId()
                        that.startRecorder()
                        that.showLoading = true
                        that.sonVideo.src = require(`../assets/${that.urlId}/video/default.mp4`)
                        that.sonVideo.play()
                        setTimeout(()=>{
                            that.endRecorder()
                        })
                    },
                });
            },

            getWidth() {
                // 获取窗口宽度 
                if (window.innerWidth) {
                    this.winWidth = window.innerWidth; 
                }else if ((document.body) && (document.body.clientWidth)) {
                    this.winWidth = document.body.clientWidth; 
                }
                // 获取窗口高度 
                if (window.innerHeight) {
                    this.winHeight = window.innerHeight; 
                }else if ((document.body) && (document.body.clientHeight)){ 
                    this.winHeight = document.body.clientHeight; 
                }
                if(this.winWidth < 500){
                    this.isPhone = true
                }
            },
            getCriticalCoefficient() {
                // console.log('屏幕宽度：'+this.winWidth,'视频高度：'+this.dataObj.videoObj.videoHeight,'屏幕高度：'+this.winHeight,'视频宽度：'+this.dataObj.videoObj.videoWidth)
                let criticalNum = ''
                criticalNum = 1/(this.winWidth*this.dataObj.videoObj.videoHeight/this.winHeight/this.dataObj.videoObj.videoWidth)
                console.log(criticalNum)
                if(criticalNum > 1){
                    criticalNum = 1
                }
                if(this.dataObj.videoObj.width > 1 || this.dataObj.videoObj.width < 0 || this.dataObj.videoObj.width == '' || this.dataObj.videoObj.width > criticalNum){
                    this.dataObj.videoObj.percent = criticalNum
                }else{
                    this.dataObj.videoObj.percent = this.dataObj.videoObj.width
                }
                if(this.dataObj.videoObj.left > 1 || this.dataObj.videoObj.left < 0 || this.dataObj.videoObj.left == '' && this.dataObj.videoObj.left != 0){
                    this.dataObj.videoObj.leftAttribute = 0.5
                }else{
                    this.dataObj.videoObj.leftAttribute = this.dataObj.videoObj.left
                }
                if(this.dataObj.videoObj.top > 1 || this.dataObj.videoObj.top < 0 || this.dataObj.videoObj.top == '' && this.dataObj.videoObj.top != 0){
                    this.dataObj.videoObj.topAttribute = 0.5
                }else{
                    this.dataObj.videoObj.topAttribute = this.dataObj.videoObj.top
                }
                let width = this.winWidth*this.dataObj.videoObj.percent
                let left = (this.winWidth - width)*this.dataObj.videoObj.leftAttribute
                let top = (this.winHeight - width*this.dataObj.videoObj.videoHeight/this.dataObj.videoObj.videoWidth)*this.dataObj.videoObj.topAttribute
                this.elevideo.setAttribute('width', width);
                this.elevideo.style.position = 'absolute'
                this.elevideo.style.left = left+'px'
                this.elevideo.style.top = top+'px'
                this.elevideo.style.zIndex = this.dataObj.videoObj.layer
                //设置底下默认视频
                this.sonVideo.setAttribute('width', width);
                this.sonVideo.style.left = left+'px'
                this.sonVideo.style.top = top+'px'
                this.sonVideo.style.zIndex = this.dataObj.videoObj.layer-1

                console.log(this.dataObj.imgList)
                for(let i = 0; i < this.dataObj.imgList.length; i++) {
                    let currentCritical = 1/(this.winWidth*this.dataObj.imgList[i].imgHeight/this.winHeight/this.dataObj.imgList[i].imgWidth)
                    if(this.dataObj.imgList[i].width > 1 || this.dataObj.imgList[i].width < 0 || this.dataObj.imgList[i].width == '' || this.dataObj.imgList[i].width > currentCritical){
                    this.dataObj.imgList[i].percent = currentCritical
                    }else{
                        this.dataObj.imgList[i].percent = this.dataObj.imgList[i].width
                    }
                    if(this.dataObj.imgList[i].left > 1 || this.dataObj.imgList[i].left < 0 || this.dataObj.imgList[i].left == '' && this.dataObj.imgList[i].left != 0){
                        this.dataObj.imgList[i].Attribute = 0.5
                    }else{
                        this.dataObj.imgList[i].Attribute = this.dataObj.imgList[i].left
                    }
                    if(this.dataObj.imgList[i].top > 1 || this.dataObj.imgList[i].top < 0 || this.dataObj.imgList[i].top == '' && this.dataObj.imgList[i].top != 0){
                        this.dataObj.imgList[i].topAttribute = 0.5
                    }else{
                        this.dataObj.imgList[i].topAttribute = this.dataObj.imgList[i].top
                    }
                    let width2 = this.winWidth*this.dataObj.imgList[i].percent
                    let left2 = (this.winWidth - width2)*this.dataObj.imgList[i].Attribute
                    let top2 = (this.winHeight - width2*this.dataObj.imgList[i].imgHeight/this.dataObj.imgList[i].imgWidth)*this.dataObj.imgList[i].topAttribute
                    this.dataObj.imgList[i].eleImg.setAttribute('width', width2) 
                    this.dataObj.imgList[i].eleImg.style.position = 'absolute'
                    this.dataObj.imgList[i].eleImg.style.left = left2+'px'
                    this.dataObj.imgList[i].eleImg.style.top = top2+'px'
                    this.dataObj.imgList[i].eleImg.style.zIndex = this.dataObj.imgList[i]['layer']
                }
            },
            getUserMedia(constrains) {
                let that = this;
                if (navigator.mediaDevices.getUserMedia) {
                    // 最新标准API
                    navigator.mediaDevices.getUserMedia(constrains).then(stream => { that.success(stream); }).catch(err => { that.error(err); });
                } else if (navigator.webkitGetUserMedia) {
                    // webkit内核浏览器
                    navigator.webkitGetUserMedia(constrains).then(stream => { that.success(stream); }).catch(err => { that.error(err); });
                } else if (navigator.mozGetUserMedia) {
                    // Firefox浏览器
                    navigator.mozGetUserMedia(constrains).then(stream => { that.success(stream); }).catch(err => { that.error(err); });
                } else if (navigator.getUserMedia) {
                    // 旧版API
                    navigator.getUserMedia(constrains).then(stream => { that.success(stream); }).catch(err => { that.error(err); });
                }
            },
            // 成功的回调函数
            success() {
                console.log("已点击允许,开启成功");
            },
            // 异常的回调函数
            error(error) {
                this.reason = "访问用户媒体设备失败："+ error.name + error.message
                console.log("访问用户媒体设备失败：", error.name, error.message);
            },
        }
    }
</script>
 
<style lang='less' scoped>
        .index{
            position: relative;
            width: 100%;
            height: 100%;
            // background: #979797;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            background-size: cover;
            background: url('../assets/img/green.jpg')
        }
        .start{
            position: absolute;
            left: 40px;
            bottom: 40px;
            z-index: 100000;
            cursor: pointer;
            width: 72px;
            img{
                width: 72px;
            }
        }
        .chat-item{
            position: absolute;
            max-width: 70%;
            color: #fff;
            font-size: 20px;
            z-index: 100000;
            bottom: 20px;
            .item-list{
                color: #fff;
                width: auto;
                display: inline-block;
                background: #000;
                opacity: 0.7;
                padding: 12px 25px;
            }
        }
</style>